import {prepareText} from '../util/format';
import React from 'react';
import {Typography} from '@/components/ui/typography';

export const TextContent = ({content, className}: {
    content: string;
    className?: string;
}) => {
    return (
        <div className={className}>
            {
                prepareText(content || '').map((it: string, index: number, parts: string[]) => (
                    <p key={index}>
                        {it}
                    </p>
                ))
            }
        </div>
    );
}
